import { useEffect } from 'react'
import { useCarousel } from './Carousel'

type AutoScrollProps = {
  rate: number
}

export const AutoScroll = ({ rate }: AutoScrollProps) => {
  const { nextPage } = useCarousel()

  useEffect(() => {
    const timer = setInterval(nextPage, rate)

    return () => clearInterval(timer)
  }, [nextPage, rate])

  return null
}
